export default __webpack_public_path__ + "static/media/Minibus.7e49321d.png";